/** @jsx jsx */
import { ReactNode } from 'react';

import { HideFooter } from '@zapier/common-components';
import { Colors } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

import useDocumentTitle from 'app/developer-v3/hooks/useDocumentTitle';

const Styles = {
  root: css`
    background-color: ${Colors.PrimeWhite};
    display: flex;
    flex: 1;
    flex-direction: column;
    height: calc(100vh - 69px);
    overflow: auto;
    position: relative;
    z-index: 0;

    code {
      background-color: ${Colors.PrimeWhite};
      border: 1px solid ${Colors.GrayWarm3};
      font-size: 13px;
      line-height: 1em;
      padding: 2px 5px;
      display: inline-block;
      text-transform: none;
    }

    p code {
      word-break: break-all;
      display: inline;
    }

    .sidebar-accordion__title {
      letter-spacing: initial;
    }

    table {
      width: 100%;
    }

    & .CodeMirror,
    & .formatic .fm-field input,
    & .formatic .fm-field textarea.fm-string,
    & .formatic .fm-field .fm-singlelinestring,
    & .formatic .fm-field .fm-pretty-select-value span.select-arrow,
    & .formatic .fm-field div.pretty-text-box {
      background-color: inherit;
      :hover {
        background-color: inherit;
      }
    },
  `,
};

type Props = {
  children: ReactNode;
};

const Developer = (props: Props) => {
  useDocumentTitle('Platform UI');
  return (
    <HideFooter>
      <div css={Styles.root} id="main">
        {props.children}
      </div>
    </HideFooter>
  );
};

export default Developer;
